import React from 'react';
import { AdvertorialPage } from './components/Advertorial/AdvertorialPage';
export function App() {
  return <AdvertorialPage data-id="element-0" />;
}